import { action, createStore, createTypedHooks } from 'easy-peasy';

import themeStore from './impl/ThemeStore';
import GlobalStore from './types/IGlobalStore';
import generalStore from './impl/GeneralStore';

const store: GlobalStore = {
  general: generalStore,
  theme: themeStore,

  update: action((state, payload) => {
    if (payload.general) {
        state.general = { ...state.general, ...payload.general };
    }
}),
};

const globalStore = createStore<GlobalStore>(store, { name: 'Global Store' });

const typedHooks = createTypedHooks<GlobalStore>();
export const useGlobalStoreActions = typedHooks.useStoreActions;
export const useGlobalStoreState = typedHooks.useStoreState;

export default globalStore;